export enum ApplicationSort {
    Asc = "ASC",
    Desc = "DESC",
}
